/**
 * card wrapper component
 * including number/password/...
 */
import { Component, Input, SimpleChanges, OnChanges, Output, EventEmitter } from '@angular/core';
import { IconDefinition } from "@fortawesome/free-regular-svg-icons";
import { faTimes, faTrash } from "@fortawesome/free-solid-svg-icons";


@Component({
    selector: 'dropdown',
    template: `
        <div class="dropdown"
             [class.menuDroplistContainer]="watabiStyle"
             [class.isOpen]="visible"
             [class.disabled]="disableToggle"
             [clickOutsideEnabled]="visible"
             (clickOutside)="hide($event)">
            <div class="toggler"
                 (click)="toggle()"
                 [class.menuToggler]="watabiStyle">
                <ng-container *ngIf="togglerIcon">
                    <div class="togglerIconMask"></div>
                    <fa-icon *ngIf="(togglerIcon && !visible) || (togglerIcon && disableToggle)"
                             class="togglerIcon"
                             [icon]="togglerIcon"
                             [class.white-label]="dropdownColorWhite">
                    </fa-icon>
                    <fa-icon *ngIf="togglerIcon && visible && !disableToggle"
                             class="togglerIcon"
                             [icon]="icons.faTimes"
                             [class.white-label]="dropdownColorWhite">
                    </fa-icon>
                </ng-container>
                <ng-content select=".dropdown-toggler"
                            (click)="toggle('true')"></ng-content>
                <!-- this following input helps to simulate the focus event to catch for opening the
                tinymce form with tab navigation as example-->
                <input *ngIf="!disableToggle" class="hiddenInput" type="text" (focus)="toggle('true')"/>
            </div>
            <div class="{{position}}">
                <div class="content adapt-position"
                     [class.visible]="visible == true"
                     [class.menuItemListContainer]="watabiStyle">
                    <ng-content select=".dropdown-content"></ng-content>
                </div>
            </div>
        </div>
    `,
    styleUrls: ["./dropdown.component.scss"],
})
export class DropdownComponent implements OnChanges {
    @Input()
    public position: string;
    @Input()
    public watabiStyle: boolean = false;
    @Input()
    public togglerIcon: IconDefinition;
    @Input()
    public showDropdown: boolean = false;
    @Input()
    public disableToggle: boolean = false;
    @Input()
    public isMultiple: boolean = false;
    @Input()
    public dropdownColorWhite: boolean = false;
    @Output()
    public readonly onToggle: EventEmitter<boolean> = new EventEmitter<boolean>();

    public visible: boolean = false;

    public icons: { [key: string]: IconDefinition } = {
        faTimes,
        faTrash
    };

    public ngOnChanges(changes: SimpleChanges): void {
        this.visible = this.showDropdown;
    }

    public hide(event: boolean): void {
        this.visible = false;
        this.onToggle.emit(this.visible)
    }

    public toggle(bool?: string): void {
        if (!this.disableToggle) {
            this.visible = bool ? bool === 'true' : !this.visible;
            this.onToggle.emit(this.visible);
        }
        this.showDropdown = this.visible;
    }

    public conditionalToggle(bool?: string): void {
        if (!this.disableToggle && !this.isMultiple) {
            this.toggle(bool);
        }
    }

    public keyAction(keyEvent: any, keyCode: string): void {
        if (keyCode === 'arrowDown') {
            if (keyEvent.srcElement.className === keyEvent.srcElement.nextSibling.className) {
                keyEvent.srcElement.nextSibling.focus();
            }
        } else if (keyCode === 'arrowUp') {
            if (keyEvent.srcElement.className === keyEvent.srcElement.previousSibling.className) {
                keyEvent.srcElement.previousSibling.focus();
            }
        }
    }
}
